import React from "react";

import Cards from './Cards';
import "./HomeDeliveries.css";

const HomeDeliveries = ({ home }) => 
  <section className="HomeDeliveries jumbotron jumbotron-fluid bg-transparent px-0 pb-0 pt-0">
    <div className="container jumbotron bg-transparent">
      <div className="d-flex justify-content-center ml-3 ml-sm-0">
        <h2 data-aos="fade-up" data-aos-easing data-aos-duration="1000" data-aos-once="true">Shipping Methods</h2>    
      </div>
      <Cards home={home[1]} />
    </div>
  </section>

export default HomeDeliveries;
